module.exports = __webpack_public_path__ + "static/bg-afb97b494edb96b4f60aca9448085175.jpg";